<template>
<div>
  <div v-if="loading" >
    <Loading />
  </div>
  <div v-else class="home" :class="[type ? type : '']">
    <div class="content">
      <div class="address">
        <!-- <i class="address-icon"></i> -->
        <i class="back-icon"></i>
        {{cname}}
      </div>
      <div class="wain" v-show="wainText">
        <i class="wain-icon"></i>
        {{wainText}}
      </div>
      <div class="temtab">
        <span :class="{activetg: tg === 'tg'}" @click="checkTem('tg')">体感温度</span>
        <span :class="{activesc: tg === 'sc'}" @click="checkTem('sc')">实测温度</span>
      </div>
      <div class="tem" v-if="tg === 'tg'">
        {{currentconditions.RealFeelTemperature.Metric.Value.toFixed(0)}}
      </div>
      <div class="tem" v-else>
        {{currentconditions.Temperature.Metric.Value.toFixed(0)}}
      </div>
      <div class="weather">
        {{currentconditions.WeatherText}}
      </div>
      <div class="info">
        <div class="wind">
          <i class="wind-icon"></i>
          {{currentconditions.Wind.Direction.Localized}}风  {{transformWind(currentconditions.Wind.Speed.Metric.Value)}}
        </div>
        <div class="humidity">
          <i class="humidity-icon"></i>
          相对湿度  {{currentconditions.RelativeHumidity}}%
        </div>
      </div>
      <div class="qx ab">
        <curve :hour_down="hour_down" :hour_rise="hour_rise" :forecastHourList="forecastHourList" :type="type" cdn="http://images-test.weelv.com/weather/icon/white" />
      </div>
      <div class="qx">

      </div>
      <div class="hour">
        <div class="fif" @click="hrefFif">
          <i class="fif-icon" v-show="!vip"></i>
          十五天预报
        </div>
      </div>
      <div v-if="indexListValues.length">
        <div class="zs" v-for="(item, index) in indexListValues" :key="index" >
          <i class="uv-icon icon" :class="[true ? 'zs' + item.ID : '']"/>
          <div>
            <p class="title">{{item.Name.replace('，由 Country Time 为您提供', '')}}<span style="margin-left: 15px">{{item.Category}}</span></p>
            <p>{{item.Text}}</p>
          </div>
        </div>
      </div>

      <div class="foot">
        <img class="logo" src="https://zky.koocdn.com/club/picture/76b79f0d3f4243f4a7c4ffe67d9ca619.png"/>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import Curve from '../components/Curve.vue'
import Loading from '../components/Loading'
import { getWeatherCurrent, getWeatherIndices , getWeatherHourly, getWeather15day, getWeatherAlerts, getMddInfo } from '../api/weather'
import dayjs from 'dayjs'
export default {
  name: 'home',
  data() {
    return {
      isShowWain: false,
      tg: 'tg',
      loading: true,
      type: 'yt',
      hour_rise: '06:01',
      hour_down: '06:01',
      forecastHourList: [

      ],
      indicesList: [],
      currentconditions: {},
      indexListValues: [],
      location: '',
      vip: false,
      name: '',
      cname: '',
      wainText: ''
    }
  },
  created() {
    const {name, cname, vip} = this.$route.query
    this.location = this.$route.params.mddid
    this.name = name || 'Maldives'
    this.cname = cname || '马尔代夫'
    this.vip = vip || false
  },
  methods: {
    checkTem(type) {
      this.tg !== type && (this.tg = type)
    },
    hrefFif() {
      if (this.vip === 'true') {
        this.$router.push(`/${this.location}/15`)
      }

    },
    transformWind(v) {
      const value = v / 3.6;
      if ( value <= 10 ) {
        return '1-2级';
      } else if (10 < value <= 17) {
        return '3-4级'
      } else if (17 < value <= 25) {
        return '4-5级'
      } else if (25 < value <= 34) {
        return '5-6级'
      } else if (34 < value <= 43) {
        return '6-7级'
      } else if (43 < value <= 54) {
        return '7-8级'
      } else if (54 < value <= 65) {
        return '8-9级'
      } else if (65 < value <= 77) {
        return '9-10级'
      } else if (77 < value <= 89) {
        return '10-11级'
      } else if (89 < value <= 102) {
        return '11-12级'
      } else {
        return '13级'
      }
    }
  },
  mounted() {
    const location = this.location

    Promise.all([getWeatherCurrent(location), getWeatherIndices(location), getWeatherHourly(location),
      getWeather15day(location), getWeatherAlerts(location), getMddInfo(location)]).then(data => {
       // 处理实况的数据
       const currentValue = data[0][0]
      this.currentconditions = currentValue
      if ([1,2,3,4,5,33,34].includes(currentValue.WeatherIcon)) {
        this.type = 'qt'
      } else if([8,11].includes(currentValue.WeatherIcon)) {
        this.type = 'yt'
      } else if([6,7,36,38].includes(currentValue.WeatherIcon)) {
        this.type = 'dy'
      } else {
        this.type = 'xy'
      }
      // 处理逐小时的数据
      this.forecastHourList = data[2].map((item, index) => {
        return {
          // hour: index === 0 ? '现在' : new Date(item.DateTime).getHours() + '时',
          hour: new Date(item.DateTime).getHours() + '时',
          icon: item.WeatherIcon,
          text: item.IconPhrase,
          tmp: item.Temperature.Value
        }
      })
      // 处理十五的数据，取出第一天的日出日落，并且缓存十五天的数据
      this.hour_rise = dayjs(data[3].DailyForecasts[0].Sun.Rise).format('HH:mm')
      this.hour_down = dayjs(data[3].DailyForecasts[0].Sun.Set).format('HH:mm')
      localStorage.setItem('fiflist', JSON.stringify(data[3].DailyForecasts))

      // 处理指数
      const indArr = ['zs10', 'zs12', 'zs11', 'zs-3', 'zs29', 'zs41', 'zs1', 'zs13', 'zs5', 'zs6']
      const indexListObj = {}

      data[1].forEach((item, index) => {
        indexListObj[`zs${item.ID}`] =  item
      })
      this.indexListValues = indArr.map(key => {
        return indexListObj[key]
      })

      // 处理预警数据
      if (data[4].length) {
        try {
          if([12,13,14,15,16,17,29,39,40,41,42].includes(data[2][1].WeatherIcon)) {
            this.wainText = '降雨警示'
          } else {
            if (this.currentconditions.RealFeelTemperature.Metric.Value > 40) {
              this.wainText = '高温警示'
            } else {
              const alarmsObj = {
                'Snow': '降雪警示',
                'Ice': '冬雪警示',
                'Wind': '大风警示',
                'WindGust': '阵风警示',
                'Thunderstorm': '雷雨警示'
              }
              const alarmsType = data[4][0].Alarms[0].AlarmType

              this.wainText = alarmsObj[alarmsType] || ''
            }
          }
        } catch (error) {

        }
      }

      if (data[5]) {
        this.name = data[5]['en_name']
        this.cname = data[5]['name']
      }
      setTimeout(() => {
        this.loading = false
      }, 200)
    })
  },
  components: {
    Curve,
    Loading
  }
}
</script>
<style lang="stylus" scoped>
@import '../stylus/mixin.styl';
.qx
  height 145px
.ab
  position absolute
  left 0
  right 0
  top 427px
.qt
  background: url('https://zky.koocdn.com/club/picture/1b69467878e74696878d21ec82244f96.jpg') center no-repeat
  background-size: cover
.yt
  background url('https://zky.koocdn.com/club/picture/b3386ff339dd436fa2f61b4bd73fcbd0.jpg') center no-repeat
  background-size cover
.xy
  background: url('https://zky.koocdn.com/club/picture/3c34a77887fb412d965aa2f5a1eef857.jpg') center no-repeat
  background-size: cover
.dy
  background url('https://zky.koocdn.com/club/picture/29d58f90e5404f0cb6ca623c1a936622.jpg') center no-repeat
  background-size cover
.home
  color rgba(255,255,255,1)
  font-family PingFangSC-Light
  font-size 13px
  .content
    padding 19px 14px 0 14px
    box-sizing border-box
    position relative
    .back-icon
      display inline-block
      width 10px
      height 20px
      background url('../assets/arrow.png') center no-repeat
      background-size cover
      position relative
      top 4px
      margin-right 13px
    .address
      font-size 15px
      font-weight 400
      line-height 15px
      font-family PingFangSC-Regular
      &-icon
        display inline-block
        width 11px
        height 13px
        background url('../assets/location.png') center no-repeat
        background-size cover
        position relative
        top 1px
    .wain
      position absolute
      top 19px
      right 11px
      height 26px
      line-height 26px
      width 93px
      background url('../assets/wainbg.png') center no-repeat
      background-size cover
      border-radius 15px
      padding 0 10px 0 11px
      &-icon
        display inline-block
        width 15px
        height 14px
        background url('../assets/horn.png') center no-repeat
        background-size cover
        position relative
        margin-right 5px
        top 2px
    .temtab
      width 149px
      height 25px
      line-height 25px
      border 1px solid rgba(255,255,255,1)
      border-radius 13px
      margin 130px auto 25px
      overflow hidden
      span
        display inline-block
        width 50%
        text-align  center
      .activetg
        background-color #28D8E8
        height 25px
        border-top-left-radius 13px
        border-bottom-left-radius 13px
      .activesc
        background-color #28D8E8
        height 25px
        border-top-right-radius 13px
        border-bottom-right-radius 13px
    .tem
        font-size 100px
        font-weight 300
        height 75px
        line-height 75px
        color rgba(255,255,255,1)
        text-align center
        position relative
        width 120px
        margin 0 auto 17px
        &:after
          position absolute
          top 0
          right -25px
          content ''
          display block
          width 14px
          height 14px
          border 2px solid rgba(255, 255, 255, 1)
          border-radius 50%
    .weather
      text-align center
      line-height 20px
      font-size 20px
      font-weight 400
      font-family PingFangSC-Regular
    .info
      font-size 15px
      font-weight 300
      display flex
      justify-content center
      div
        margin 36px 20px
      .wind
        &-icon
          display inline-block
          width 18px
          height 18px
          line-height 18px
          background url('../assets/wind.png') center no-repeat
          background-size cover
          position relative
          top 4px
      .humidity
        &-icon
          display inline-block
          width 18px
          height 18px
          line-height 18px
          background url('../assets/humidity.png') center no-repeat
          background-size cover
          position relative
          top 4px
    .hour
      // margin 0 14px
      height 49px
      border-top-1px(rgba(255,255,255,0.1))
      display flex
      justify-content flex-end
      align-items center
      .fif
        width 112px
        height 28px
        line-height 28px
        text-align center
        background rgba(67,67,69,1)
        border-radius 14px
        font-size 12px
        color #E0C774
        font-size 12px
        font-weight 300
        &-icon
          display inline-block
          width 11px
          height 14px
          background url('../assets/suo.png') center no-repeat
          background-size cover
          position relative
          top 3px
          left -6px
    .zs
      height 95px
      margin 0 14px
      border-top-1px(rgba(255,255,255,.1))
      display flex
      align-items center
      justify-content space-around
      font-size 11px
      line-height 1.5
      font-weight 400
      color rgba(255,255,255,.6);
      .icon
        width 42px
        height 42px
        display block
        margin-right 15px
      .zs10
        background url('https://zky.koocdn.com/club/picture/79844cca0e474cb0ba05f6336474060d.png') center no-repeat
        background-size cover
      .zs29
        background url('https://zky.koocdn.com/club/picture/1ce677204caa4880a1b6b6d4f349bde3.png') center no-repeat
        background-size cover
      .zs41
        background url('../assets/zs41.png') center no-repeat
        background-size cover
      .zs13
        background url('https://zky.koocdn.com/club/picture/0c042e77bed84a2c800e9b987eef4eda.png') center no-repeat
        background-size cover
      .zs12
        background url('https://zky.koocdn.com/club/picture/a63db6a7ba1a4173a387c59d4cb27f4c.png') center no-repeat
        background-size cover
      .zs11
        background url('https://zky.koocdn.com/club/picture/2e94ceb4dc7743daba91afa50bbaf5e0.png') center no-repeat
        background-size cover
      .zs6
        background url('https://zky.koocdn.com/club/picture/b723dbdb7d7b41e886d1c9421d590827.png') center no-repeat
        background-size cover
      .zs5
        background url('../assets/zs5.png') center no-repeat
        background-size cover
      .zs1
        background url('https://zky.koocdn.com/club/picture/16224d5cd5d94aa88573c836c785cbad.png') center no-repeat
        background-size cover
      .zs-3
        background url('https://zky.koocdn.com/club/picture/7bf746c3eeff48219da562559745f941.png') center no-repeat
        background-size cover
      .title
        font-size 15px
        font-weight 400
        color #fff
        margin-bottom 3px
      div
        flex 1
    .foot
      height 72px
      margin 0 14px
      border-top-1px(rgba(255,255,255,.1))
      display flex
      justify-content flex-end
      align-items center
      .logo
        width 186px
        height 23px
</style>
